import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { projectSettingServicedeskEmployeeOnboardingConfigurationRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskEmployeeOnboardingConfigurationRoute.tsx';
import ServicedeskEmployeeOnboardingConfigurationComponent, {
	LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration,
} from './ui/service-desk-employee-onboarding-configuration/ServicedeskEmployeeOnboardingConfigurationComponent.tsx';

export const projectSettingServicedeskEmployeeOnboardingConfigurationRouteEntry: ReturnType<
	typeof createEntry
> = createEntry(projectSettingServicedeskEmployeeOnboardingConfigurationRoute, () => ({
	group: 'project-settings-servicedesk',
	ufoName: 'jsm-employee-onboarding-configuration',
	component: ServicedeskEmployeeOnboardingConfigurationComponent,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
		sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
	},

	resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
	forPaint: [
		LazyAtlassianNavigation,
		LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration,
	],
	perfMetricKey: 'jsm-employee-onboarding-configuration',

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingServicedeskEmployeeOnboardingConfigurationRouteEntry.tsx',
			whichExportToUse: 'projectSettingServicedeskEmployeeOnboardingConfigurationRouteEntry',
		},

		enabled: true,
	},
}));
